import { render, staticRenderFns } from "./ErrorBanner.vue?vue&type=template&id=bdbfe28e&scoped=true&"
import script from "./ErrorBanner.vue?vue&type=script&lang=js&"
export * from "./ErrorBanner.vue?vue&type=script&lang=js&"
import style0 from "./ErrorBanner.vue?vue&type=style&index=0&id=bdbfe28e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdbfe28e",
  null
  
)

export default component.exports